import { Route, Switch } from 'react-router-dom';
import MainLayout from '../layout/Main';
import EstimateLayout from '../layout/Estimate';
import ServiceReceiptPage from './ServiceReceipt';
import EstimatePage from './Estimate';

const routes = () => (
  <Switch>
    <Route
      path='/service-receipt'
      render={(route) => <MainLayout component={ServiceReceiptPage} route={route} />}
    />
    <Route
      path='/estimate/:token'
      render={(route) => <EstimateLayout component={EstimatePage} route={route} />}
    />
  </Switch>
);

export default routes;
